import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import {
  GlobeIcon,
  HeaderPill,
  HeaderPillToggle,
  HeaderPillMenu,
  HeaderPillOption,
  PillCaret,
} from './dropdown'
import { Typography } from '../styled'
import { useTheme } from '../../contexts/themeContext'

const locales = {
  en: 'English',
  ar: 'العربية',
  gr: 'Deutsch',
}

const LanguageLabel = styled(Typography)({
  whiteSpace: 'nowrap',
  fontSize: '14px',
})

export default function LanguagesDropdown() {
  const { i18n } = useTranslation()
  const { theme } = useTheme()
  const [menu, setMenu] = React.useState(false)
  const ref = React.useRef(null)

  useEffect(() => {
    const dir = i18n.dir(i18n.language)
    document.documentElement.dir = dir
  }, [i18n, i18n.language])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <HeaderPill show={menu} onToggle={() => setMenu(!menu)} align="end">
      <HeaderPillToggle
        height="34px"
        tag="button"
        color={theme.headerItemColor}
        aria-label={locales[i18n.language] || i18n.language}
        title={locales[i18n.language] || i18n.language}
      >
        <GlobeIcon width={16} height={16} color={theme.headersMiniTitle} />
        <LanguageLabel color={theme.headerItemColor}>
          {locales[i18n.language] || i18n.language}
        </LanguageLabel>
        <PillCaret width={12} height={12} />
      </HeaderPillToggle>
      <HeaderPillMenu>
        {Object.keys(locales).map((locale) => (
          <HeaderPillOption
            key={locale}
            type="button"
            $active={locale === i18n.language}
            onClick={() => {
              i18n.changeLanguage(locale)
              setMenu(false)
            }}
          >
            {locales[locale]}
          </HeaderPillOption>
        ))}
      </HeaderPillMenu>
    </HeaderPill>
  )
}
